console.log("sticky nav loaded");
let lastScrollTop = 0;

window.addEventListener('scroll', function() {
  const element = document.querySelector('.handbuch-float-nav');
  const rect = element.getBoundingClientRect();
  const elementOffsetTop = rect.top;
  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollTop > lastScrollTop) {
    // Scrolling down
    if (elementOffsetTop <= 0) {
      element.style.position = 'fixed';
      element.style.top = '0';
    }
  } else {
    // Scrolling up
    if (currentScrollTop <= element.offsetTop) {
      element.style.position = 'relative';
      element.style.top = '';
    }
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
});